import { Redesign2025Masthead } from "components/masthead/redesign2025-masthead";
import MastheadCartDropdownLoader from "./masthead-cart-dropdown-loader-class";
import MastheadCartDropdownItems from "./masthead-cart-dropdown-items-class";
import MastheadCartDropdownEvents from "./masthead-cart-dropdown-events-class";

// Constants
const SELECTORS = {
  CART_DROPDOWN_MENU: ".js-cart-dropdown-menu"
};

const initCartDropdown = () => {
  // Initialize masthead component
  const masthead = new Redesign2025Masthead({
    selector: SELECTORS.CART_DROPDOWN_MENU
  });
  masthead.init();

  // Initialize loader
  const loader = new MastheadCartDropdownLoader();

  // Initialize cart items management with loader dependency
  const cartItems = new MastheadCartDropdownItems({
    loader
  });
  cartItems.init();

  // Initialize events management with dependencies
  const events = new MastheadCartDropdownEvents({
    cartItems,
    loader
  });
  events.init();

  return { masthead, loader, cartItems, events };
};

const init = () => {
  initCartDropdown();
};

export default init;
